import AirDatepicker from 'air-datepicker';

const localeEn = {
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  monthsShort: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
  today: 'Today',
  clear: 'Clear',
  dateFormat: 'MM/dd/yyyy',
  timeFormat: 'hh:mm aa',
  firstDay: 0,
};

window.dateInput = function dateInput() {
  if (document.getElementsByClassName('date-input')[0]) {
    const dateInputsArr = document.querySelectorAll('.date-input');

    dateInputsArr.forEach((dateInput) => {
      if (!dateInput.classList.contains('is-init')) {
        dateInput.classList.add('is-init');

        const isStartDateInput =
          dateInput.classList.contains('start-date-input');
        const isEndDateInput = dateInput.classList.contains('end-date-input');
        const endDateRange = isEndDateInput
          ? parseInt(dateInput.getAttribute('data-end-date'), 10)
          : null;

        // Получаем родителя родителя
        const grandParent =
          dateInput.parentElement?.parentElement.parentElement;

        // Инициализируем AirDatepicker
        const airDatepicker = new AirDatepicker(dateInput, {
          dateFormat: 'dd/MM/yyyy',
          locale: localeEn,
          onSelect: function (formattedDate, date) {
            dateInput.value = formattedDate.formattedDate;

            // Если это start-date-input, сохраняем дату в data-start-date
            if (isStartDateInput && grandParent) {
              grandParent.setAttribute(
                'data-start-date',
                formattedDate.formattedDate
              );
            }

            // При изменении start-date, обновляем ограничения для end-date
            if (isStartDateInput && grandParent) {
              updateEndDateConstraints(grandParent);
            }
          },
          onRenderCell: function ({ date }) {
            if (isEndDateInput && endDateRange) {
              let startDate = new Date(); // По умолчанию сегодняшняя дата
              startDate.setHours(0, 0, 0, 0);

              // Проверяем data-start-date
              if (grandParent && grandParent.getAttribute('data-start-date')) {
                const [day, month, year] = grandParent
                  .getAttribute('data-start-date')
                  .split('/');
                startDate = new Date(`${year}-${month}-${day}`);
                startDate.setHours(0, 0, 0, 0);
              }

              // Считаем минимальную доступную дату (startDate + 1 день)
              const minDate = new Date(startDate);
              minDate.setDate(startDate.getDate() + 1);

              // Считаем максимальную доступную дату (startDate + 30 дней)
              const maxDate = new Date(startDate);
              maxDate.setDate(startDate.getDate() + endDateRange);

              // Блокируем даты до minDate и после maxDate
              if (date < minDate || date > maxDate) {
                return {
                  disabled: true,
                };
              }
            }
          },
          onShow: function () {
            // Срабатывает при открытии календаря
            if (isEndDateInput && grandParent) {
              const startDateValue =
                grandParent.getAttribute('data-start-date');
              let startDateObj = new Date();

              if (startDateValue) {
                const [day, month, year] = startDateValue.split('/');
                startDateObj = new Date(`${year}-${month}-${day}`);
              }

              startDateObj.setHours(0, 0, 0, 0);

              // Считаем минимальную дату (startDate + 1 день)
              const minDate = new Date(startDateObj);
              minDate.setDate(startDateObj.getDate() + 1);

              // Считаем максимальную дату (startDate + 30 дней)
              const maxDate = new Date(startDateObj);
              maxDate.setDate(startDateObj.getDate() + endDateRange);

              airDatepicker.update({
                minDate: new Date(), // Минимальная дата - сегодня
                maxDate: new Date().setFullYear(new Date().getFullYear() + 1), // Максимальная дата - через год
              });

              // Применяем ограничения
              airDatepicker.update({
                minDate: minDate, // Минимальная дата - это startDate + 1
                maxDate: maxDate, // Максимальная дата - это startDate + 30 дней
              });

              // Логирование для проверки
              console.log('Start Date:', startDateObj);
              console.log('Min Date:', minDate);
              console.log('Max Date:', maxDate);
            }
          },
        });

        // Если это start-date-input, добавляем обновление ограничений для end-date-input
        if (isStartDateInput && grandParent) {
          const endDateInput = grandParent.querySelector('.end-date-input');
          if (endDateInput) {
            dateInput.addEventListener('change', () => {
              // Обновляем ограничения в end-date-input
              updateEndDateConstraints(grandParent);
            });
          }
        }

        // При открытии календаря для end-date-input обновляем его ограничения
        if (isEndDateInput && grandParent) {
          const startDate = grandParent.querySelector('.start-date-input');
          if (startDate) {
            // Слушаем событие "open", когда календарь будет открыт
            airDatepicker.on('open', function () {
              const startDateValue =
                grandParent.getAttribute('data-start-date');
              let startDateObj = new Date();

              if (startDateValue) {
                const [day, month, year] = startDateValue.split('/');
                startDateObj = new Date(`${year}-${month}-${day}`);
              }

              startDateObj.setHours(0, 0, 0, 0);

              // Считаем минимальную дату (startDate + 1 день)
              const minDate = new Date(startDateObj);
              minDate.setDate(startDateObj.getDate() + 1);

              // Считаем максимальную дату (startDate + 30 дней)
              const maxDate = new Date(startDateObj);
              maxDate.setDate(startDateObj.getDate() + endDateRange);

              // Применяем ограничения
              airDatepicker.update({
                minDate: minDate, // Минимальная дата - это startDate + 1
                maxDate: maxDate, // Максимальная дата - это startDate + 30 дней
              });

              // Логирование для проверки
              console.log('Start Date:', startDateObj);
              console.log('Min Date:', minDate);
              console.log('Max Date:', maxDate);
            });
          }
        }

        dateInput.setAttribute('readonly', 'true');
        dateInput.setAttribute('autocomplete', 'off');
        dateInput.setAttribute('inputmode', 'none');
      }
    });
  }
};

function newAirEndDatepicker(grandParent) {
  const endInput = grandParent.querySelector('.end-date-input');

  if (endInput) {
    const savedBlock = endInput.cloneNode(true);
    savedBlock.classList.remove('is-init');

    const parent = endInput.parentElement;

    const nextSibling = endInput.nextElementSibling;

    parent.removeChild(endInput);

    if (nextSibling) {
      parent.insertBefore(savedBlock, nextSibling);
    } else {
      parent.appendChild(savedBlock);
    }

    dateInput();
  }
}

function updateEndDateConstraints(grandParent) {
  const endDateInput = grandParent.querySelector('.end-date-input');
  if (endDateInput) {
    const startDateValue = grandParent.getAttribute('data-start-date');
    let startDateObj = new Date();

    if (startDateValue) {
      const [day, month, year] = startDateValue.split('/');
      startDateObj = new Date(`${year}-${month}-${day}`);
    }

    startDateObj.setHours(0, 0, 0, 0);

    // Считаем минимальную дату (startDate + 1 день)
    const minDate = new Date(startDateObj);
    minDate.setDate(startDateObj.getDate() + 1);

    // Считаем максимальную дату (startDate + 30 дней)
    const maxDate = new Date(startDateObj);
    maxDate.setDate(startDateObj.getDate() + 30);

    const airDatepicker = endDateInput.airdatepicker;
    if (airDatepicker) {
      // Обновляем ограничения для endDate
      airDatepicker.update({
        minDate: minDate, // Минимальная дата - это startDate + 1
        maxDate: maxDate, // Максимальная дата - это startDate + 30 дней
      });

      // Логируем для отладки
      console.log('Updated End Date Constraints');
      console.log('Min Date:', minDate);
      console.log('Max Date:', maxDate);

      // Проверяем, если выбранная дата в end-date выходит за пределы допустимого диапазона
      const selectedEndDate = new Date(endDateInput.value);
      if (selectedEndDate < minDate) {
        endDateInput.value = airDatepicker.formatDate(minDate);
      } else if (selectedEndDate > maxDate) {
        endDateInput.value = airDatepicker.formatDate(maxDate);
      }
    }

    newAirEndDatepicker(grandParent);
  }
}

dateInput();

const addNewButtons = document.querySelectorAll('.profile-block__new');

if (addNewButtons.length) {
  addNewButtons.forEach((item) => {
    item.addEventListener('click', () => {
      setTimeout(() => {
        console.log('test init');

        dateInput();
      }, 1);
    });
  });
}
